import { render } from "./ConfirmAddressModal.vue?vue&type=template&id=c8571db0"
import script from "./ConfirmAddressModal.vue?vue&type=script&lang=js"
export * from "./ConfirmAddressModal.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_6e4c079c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__